import React from 'react';
import SEOHead from '../components/SEOHead';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import { Service } from '../types';

interface HomePageProps {
  onBookingClick: () => void;
  onServiceSelect: (service: Service) => void;
}

const HomePage: React.FC<HomePageProps> = ({ onBookingClick, onServiceSelect }) => {
  return (
    <>
      <SEOHead page="home" />
      <HeroSection onBookingClick={onBookingClick} />
      <ServicesSection onServiceSelect={onServiceSelect} />
      <AboutSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
};

export default HomePage;